import React from "react";

const Newsletter = ({config, cdnpath}) => {
    return (
        <div className="background-secondary">
            <div className="Newsletter">
                <div id="NewsletterSignUp">
                    <div className="cover-img">
                        <img src={`${cdnpath}assets/${config.image.src}`} alt={config.image.alt} title={config.image.title}/>
                    </div>
                    <div className="cover-text">
                        <div className="h1 text-white">Stay Connected {config.name != "Default" ? `with ${config.name}` : null}</div>
                        <p className="text-white">Click below to subscribe to Lab Manager's {config.fullName} eNewsletter!</p>
                        <button className="action-btn btn brandedButton inverted" onClick={() => {
                            window.open(config.button.url,'_blank');
                        }}>{config.button.text}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Newsletter;
